import React, { useState, useEffect } from 'react';
import "../Users/UploadDocuments.css";
import api from '../../services/api';
import useAuth from '../../hooks/useAuth';
import ScreenLoader from '../HtmlElements/ScreenLoader';
import Alert from '../HtmlElements/Alert';
import UserPreferenceSidebar from './UserPreferenceSidebar';

export default function UploadDocuments() {
  useAuth();

  const [loader, setLoader] = useState(false);
  const [apiSuccess, setApiSuccess] = useState('');
  const [apiError, setApiError] = useState('');
  const [templateFiles, setTemplateFiles] = useState([]);
  const [pitchFiles, setPitchFiles] = useState([]);

  const fetchFiles = async (section, setter) => {
    try {
      const res = await api.get("/documents/list_documents");
      const filtered = res?.data?.result?.filter(file => file.document_type === section);
      setter(filtered || []);
    } catch (err) {
      console.error(`Error fetching ${section} files:`, err);
    }
  };

  const uploadFile = async (file, section, refresh) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("document_type", section);

    try {
      const response = await api.post("/documents/upload_file", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      refresh();

      if (response?.data?.status === 400 || response?.data?.status === 401) {
        setApiError("Unsupported file type");
      } else {
        setApiSuccess("File uploaded successfully!");
      }
    } catch (err) {
      setApiError("Couldn't upload file, please try again later");
    }

    setTimeout(() => {
      setApiSuccess("");
      setApiError("");
    }, 5000);
  };

  useEffect(() => {
    fetchFiles("Template", setTemplateFiles);
    fetchFiles("Pitch", setPitchFiles);
  }, []);

  const handleDocFileChange = (event, section, setter) => {
    const file = event.target.files[0];
    if (file) {
      uploadFile(file, section, () => fetchFiles(section, setter));
      event.target.value = ""; // reset file input
    }
  };

  const renderTable = (title, data, section, setter) => (
    <div className="mb-4">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5>{title}</h5>
        <label className="btn btn-primary">
          Add Document
          <input
            type="file"
            hidden
            onChange={(e) => handleDocFileChange(e, section, setter)}
          />
        </label>
      </div>

      <div className='table_doc_block'>
        <div className='table-responsive'>
          <table className='table_doc'>
            <thead>
              <tr className='table_doc_th'>
                <th className='table_doc_th'>Document Name</th>
                <th className='table_doc_th'>Impact Areas</th>
                <th className='table_doc_th'>Upload Date</th>
              </tr>
            </thead>
            <tbody className='table_doc_tbody'>
              {data.length === 0 ? (
                <tr className='table_doc_tr'>
                  <td className='table_doc_td' colSpan={3}>No documents found</td>
                </tr>
              ) : (
                data.map((doc, idx) => (
                  <tr className='table_doc_tr' key={idx}>
                    <td className='table_doc_td'>{doc.filename || "-"}</td>
                    <td className='table_doc_td'>{doc.impact_areas || "-"}</td>
                    <td className='table_doc_td'>{doc.modified_date || "-"}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );

  return (
    <div className="user_profile_wrapper">
      {loader && <ScreenLoader />}
      <div className="container-fluid">
        <div className="user_profile_subblock">
          {apiError && <Alert type="danger" message={apiError} />}
          {apiSuccess && <Alert type="success" message={apiSuccess} />}
          <div className="row">
            <div className="col-md-2" style={{ borderRight: "solid 0.1rem #98A4AA33" }}>
              <div className="sidebar_profile">
                <UserPreferenceSidebar />
              </div>
            </div>
            <div className="col-md-10">
              {renderTable("Template", templateFiles, "Template", setTemplateFiles)}
              {/* {renderTable("Pitch Documents", pitchFiles, "Pitch", setPitchFiles)} */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}